import { ContractEndorsementBannerLoading } from '@features/contract-endorsement-banner';
import { getDocumentMode } from '@helpers/getDocumentMode';
import { DocumentMode } from '@root/@types/types';

import { NavigationLoading } from '../../navigation';

import { ContractBuilderBaseLoading } from './ContractBuilderBaseLoading';

export const ContractBuilderContractViewLoading = () => {
  const { mode } = getDocumentMode(location.pathname);
  const isEndorsement = mode === DocumentMode.ENDORSEMENTS;

  return (
    <ContractBuilderBaseLoading headerRow={isEndorsement && <ContractEndorsementBannerLoading />}>
      <>
        <div className="max-w-drawer w-1/3 bg-white">
          <div className="flex h-[50px] animate-pulse items-center justify-between px-4">
            <div className="bg-info-200 h-4 w-24 rounded-full" />
            <div className="bg-info-200 h-5 w-5 rounded-sm" />
          </div>
          <div className="border-info-200 mb-2 border-b"></div>
          <NavigationLoading />
        </div>
        <div className="grow overflow-hidden pt-6">
          <div className="page-A4-width 3xl:mx-auto mx-8 mt-20 flex h-full animate-pulse flex-col gap-y-5 bg-white px-5 py-5 shadow-lg 2xl:mx-44">
            <div className="bg-info-200 h-3 w-3/4 rounded-full" />
            <div className="bg-info-200 h-3 w-1/2 rounded-full" />
            <div className="bg-info-200 h-3 w-3/4 rounded-full" />
            <div className="bg-info-200 h-3 w-3/4 rounded-full" />
            <div className="bg-info-200 h-3 w-full rounded-full" />
            <div className="bg-info-200 h-3 w-3/4 rounded-full" />
            <div className="bg-info-200 h-3 w-1/2 rounded-full" />
            <div className="bg-info-200 h-3 w-1/2 rounded-full" />
            <div className="bg-info-200 h-3 w-3/4 rounded-full" />
            <div className="bg-info-200 h-3 w-3/4 rounded-full" />
            <div className="bg-info-200 h-3 w-full rounded-full" />
            <div className="bg-info-200 h-3 w-1/2 rounded-full" />
            <div className="bg-info-200 h-3 w-3/4 rounded-full" />
            <div className="bg-info-200 h-3 w-3/4 rounded-full" />
            <div className="bg-info-200 h-3 w-3/4 rounded-full" />
            <div className="bg-info-200 h-3 w-3/4 rounded-full" />
          </div>
        </div>
      </>
    </ContractBuilderBaseLoading>
  );
};
